import { useEffect } from 'react';

/** Esc 키로 다이얼로그 닫기 — 공통 팝업(AppDialog)이 떠 있으면 그쪽이 먼저 처리하므로 건너뛴다 */
export function useEscapeKey(onClose: () => void, enabled = true) {
  useEffect(() => {
    if (!enabled) return;
    const h = (e: KeyboardEvent) => {
      if (e.key !== 'Escape') return;
      if (document.querySelector('[data-app-dialog]')) return;
      onClose();
    };
    window.addEventListener('keydown', h);
    return () => window.removeEventListener('keydown', h);
  }, [onClose, enabled]);
}
